<template>
    <div>

        <OcorrenciaInfo :idOcorrencia="idOcorrencia" :refreshStatus="refresh_grid2" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />

        <div class="container-fluid">
            <div class="row">

                <div class="col">
                    <Card_Title :class_color="'bg-color-1'">
                        <template v-slot:context>
                            <span class="span-1">Tarefas a Responder</span>
                        </template>
                    </Card_Title>

                    <!-- A RESPONDER -->

                    <DataTable :url_ajax="getUrlTarefas(1)" :ajax_set_result="setTable" :request_api="'comercial'"
                        @data_loaded="(data) => { lst_tarefas = data.rows; validationAvancarEtapa() }"
                        @grid_refreshed="gridRefreshed1" :refresh="refresh_grid1" :filtros="filtro" method="GET"
                        :qtd_registros_por_pagina="50" :is_table="false" :is_modal="true" :footer_fixed="false"
                        :hasPadding="'p-0'"
                        :customHeight="'max-height: calc(100vh - 21rem);margin-right:0px;margin-left:0px;box-shadow:none;margin-top:5px !important'"
                        :customContainer="'padding-left:0px'" :is_NotLoading="true">

                        <template v-slot:rows="{ rows }">
                            <div v-for="tarefa in rows" :key="tarefa.idSetorClassificacaoEtapaTarefa">
                                <Card_Title :class_color="'bg-color-1'">
                                    <template v-slot:context>
                                        <span class="label-tarefa">{{ tarefa.nmTarefa }}</span><span v-if="tarefa.flObrigatorio == true"> *</span>

                                        <div class="mt-4">
                                            <!-- DESCRITIVO -->
                                            <textarea v-if="tarefa.cdTipoTarefa === 'DE'" class="form-control"
                                                id="exampleFormControlTextarea1" rows="3" v-model="tarefa.dsObservacao"
                                                placeholder="Escreva..." @change="updateTarefa(tarefa)"></textarea>


                                            <!-- DATA -->
                                            <DateInput v-else-if="tarefa.cdTipoTarefa === 'DT'"
                                                v-model="tarefa.dsObservacao" class="col-12" :customWidth="customWidthDate"
                                                @change="updateTarefa(tarefa)" dateFormat="DD/MM/YYYY" />
                                            <!-- <input v-else-if="tarefa.cdTipoTarefa === 'DT'" type="text" class="form-control"
                                                v-model="tarefa.dsObservacao" placeholder="Data" v-maska="'##/##/####'"
                                                @change="updateTarefa(tarefa)"> -->



                                            <!-- SIM/NAO -->
                                            <div v-else-if="tarefa.cdTipoTarefa === 'SN'">
                                                <div class="radio-group" @change="updateTarefa(tarefa)">

                                                    <label class="radio-label">
                                                        <input type="radio" value="Sim" v-model="tarefa.dsObservacao">
                                                        <span class="radio-custom"></span>
                                                        <span class="radio-text">Sim</span>
                                                    </label>
                                                    <label class="radio-label">
                                                        <input type="radio" value="Não" v-model="tarefa.dsObservacao">
                                                        <span class="radio-custom"></span>
                                                        <span class="radio-text">Não</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-row-reverse bd-highlight">
                                            <div v-if="tarefa.dsLoginAlteracao !== null">
                                                <span class="label-alteracao">
                                                    Ultima alteração realizada por {{
                                                        tarefa.dsLoginAlteracao
                                                    }} em 09/02/2021
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                </Card_Title>
                            </div>

                        </template>
                    </DataTable>
                </div>



                <!-- RESPONDIDAS -->

                <div class="col">
                    <Card_Title :class_color="'bg-color-3'">
                        <template v-slot:context>
                            <span class="span-2">Tarefas Respondidas</span>
                        </template>
                    </Card_Title>
                    <DataTable :url_ajax="getUrlTarefas(2)" :ajax_set_result="setTable" @grid_refreshed="gridRefreshed2"
                        :refresh="refresh_grid2" :filtros="filtro" method="GET" :qtd_registros_por_pagina="50"
                        :is_table="false" :is_modal="true" :footer_fixed="false" :hasPadding="'p-0'"
                        :customHeight="'max-height: calc(100vh - 21rem);margin-right:0px;margin-left:0px;box-shadow:none;margin-top:5px !important'"
                        :customContainer="'padding-left:0px'" :is_NotLoading="true" :request_api="'comercial'">
                        <template v-slot:rows="{ rows }">


                            <div v-for="tarefa in rows" :key="tarefa.idSetorClassificacaoEtapaTarefa">
                                <Card_Title :class_color="'bg-color-3'">
                                    <template v-slot:context>
                                        <span class="label-tarefa">{{ tarefa.nmTarefa }}</span>

                                        <div class="mt-4">
                                            <!-- DESCRITIVO -->
                                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                                                v-model="tarefa.dsObservacao" placeholder="Escreva.."
                                                v-if="tarefa.cdTipoTarefa === 'DE'"
                                                @change="updateTarefa(tarefa)"></textarea>

                                            <!-- DATA -->
                                            <DateInput v-else-if="tarefa.cdTipoTarefa === 'DT'"
                                                v-model="tarefa.dsObservacao" class="col-12" :customWidth="customWidthDate"
                                                @change="updateTarefa(tarefa)" dateFormat="DD/MM/YYYY" />

                                            <!-- <input type="text" class="form-control" v-model="tarefa.dsObservacao"
                                                placeholder="Data" v-maska="'##/##/####'"
                                                v-else-if="tarefa.cdTipoTarefa === 'DT'" @change="updateTarefa(tarefa)"> -->


                                            <!-- SIM/NAO -->
                                            <div v-else-if="tarefa.cdTipoTarefa === 'SN'">
                                                <div class="radio-group" @change="updateTarefa(tarefa)">
                                                    <label class="radio-label">
                                                        <input type="radio" value="Sim" v-model="tarefa.dsObservacao">
                                                        <span class="radio-custom-done"></span>
                                                        <span class="radio-text">Sim</span>
                                                    </label>
                                                    <label class="radio-label">
                                                        <input type="radio" value="Não" v-model="tarefa.dsObservacao">
                                                        <span class="radio-custom-done"></span>
                                                        <span class="radio-text">Não</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="d-flex flex-row-reverse bd-highlight">
                                            <div v-if="tarefa.dsLoginAlteracao !== null">
                                                <span class="label-alteracao text-muted">
                                                    Respondida por {{
                                                        tarefa.dsLoginAlteracao
                                                    }} em
                                                    {{ getFormattedDate(tarefa.dtRealizacao) }}
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                </Card_Title>
                            </div>
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import OcorrenciaInfo from '@/components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
import Card_Title from '../../../../components/App/Card_Title.vue'
import DataTable from '@/components/App/Datatable.vue'
import moment from 'moment';
import DateInput from "@/components/App/DateInput.vue";


export default {
    name: 'Tarefas Executar',
    emits: [
        'liberaAvancarEtapa',
        'liberaUltimaEtapa',
        'reloadGridOcorrencias'
    ],
    components: {
        OcorrenciaInfo,
        Card_Title,
        DataTable,
        DateInput
    },
    props: {
        idOcorrencia: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            p_idOcorrencia: 0,

            refresh_grid1: false,
            refresh_grid2: false,

            filtro: [
                { active: true },
            ],
            lst_tarefas: [],

            customWidthDate: '',
            ocorrencia: {},
        }
    },
    methods: {
        getOcorrencia() {
            let $this = this;

            axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                headers: $this.$api.getTokenComercial(),
                params: ''
            }).then(response => {
                $this.ocorrencia = response.data.data;
            })
        },
        updateSizeDinamic() {
            if (window.innerWidth <= 1400) {
                this.customWidthDate = 'width: 103%'

            } else if (window.innerWidth >= 3500) {

                this.customWidthDate = 'width: 107%'

            } else {
                this.customWidthDate = 'width: 105%'
            }

        },
        getFormattedDate(date) {
            return moment(date).format("DD/MM/YYYY [ás] hh[h]mm")
        },
        gridRefreshed1(data_ajax) {
            this.refresh_grid1 = false;
        },
        gridRefreshed2(data_ajax) {
            this.refresh_grid2 = false;
        },
        reloadGrids() {
            this.refresh_grid1 = true;
            this.refresh_grid2 = true;
        },
        getUrlTarefas(status) {
            return process.env.VUE_APP_ROOT_COMERCIAL_API + '/SetorClassificacaoEtapaTarefa/Get?idOcorrencia=' + this.idOcorrencia + '&tpStatus=' + status;
        },
        updateTarefa(tarefa) {
            if (tarefa.dsObservacaoOld != tarefa.dsObservacao) {

                switch (tarefa.cdTipoTarefa) {
                    case 'DT':
                        if (window.DateIsValid(new Date(tarefa.dsObservacao)) == false && (tarefa.dsObservacao == '' || tarefa.dsObservacao == null)) {
                            this.$toast.show('alert', 'Data inválida !', true);
                            return;
                        }
                        break;
                    case 'SN':
                        if (tarefa.dsObservacao == 'Selecione') {
                            tarefa.dsObservacao = '';
                        }
                        break;
                    default:
                        break;
                }

                this.lst_tarefas = this.lst_tarefas.map(task => {

                    if (task.idSetorClassificacaoEtapaTarefa == tarefa.idSetorClassificacaoEtapaTarefa) {
                        return tarefa
                    }

                    return task;
                });
            }
            var content = { idSetorClassificacaoEtapaTarefa: tarefa.idSetorClassificacaoEtapaTarefa, idOcorrencia: tarefa.idOcorrencia, dsObservacao: tarefa.dsObservacao };
            this.saveTarefa(content);
        },
        validationAvancarEtapa() {

            const tarefas = this.lst_tarefas.filter(t => {

                if (t.flObrigatorio) {

                    if (t.dsObservacao && t.dsObservacao != "") return false;

                    return true;
                }

                return false;
            });

            let valida = !tarefas.length;

            this.$emit('liberaAvancarEtapa', valida);
        },
        saveTarefa(content) {
            let $this = this;

            axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/OcorrenciaTarefa/Post', content, { headers: $this.$api.getTokenComercial() })
                .then(function (response) {
                    setTimeout(() => {
                        $this.reloadGrids();
                        /* $this.$forceUpdate();*/
                        $this.validationAvancarEtapa();
                        $this.GetVerificaUltimaEtapa();
                    }, 200);
                })
                .catch(function (error) {
                    var msg = 'Ocorreu um erro inesperado';
                    if (error.response) {
                        if (error.response.data.erros != '') {
                            msg = error.response.data.errors[0];
                        } else {
                            msg = error.response.data.msg;
                        }
                    }

                    $this.$toast.show('alert', msg, true);
                });
        },
        async postAvancarEtapa() {

            const tarefas = this.lst_tarefas.filter(t => {

                if (t.flObrigatorio) {

                    if (t.dsObservacao && t.dsObservacao != "") return false;
                    return true;
                }

                return false;
            });

            const valida = !tarefas.length;

            if (!valida) {
                this.$toast.show('alert', 'Existe tarefa pendente.', true);
                return;
            }
            const response = await axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/UpdateClassificacaoEtapa/' + this.p_idOcorrencia, null, { headers: this.$api.getTokenComercial() })
                .then((response) => {
                    this.$nextTick(() => {
                        this.$emit('reloadGridOcorrencias');
                    })
                    if (response.data.msg == 'Finalizou o Ticket.') {
                        var myModalEl = document.getElementById('ModalTicket');
                        var ModalPedidoFat = window.bootstrap.Modal.getInstance(myModalEl);
                        ModalPedidoFat.hide();
                    } else {
                        this.reloadGrids();
                    }
                })
                .catch(function (error) {
                    var msg = 'Ocorreu um erro inesperado';
                    if (error.response) {
                        if (error.response.data.erros != '') {
                            msg = error.response.data.errors[0];
                        } else {
                            msg = error.response.data.msg;
                        }
                    }
                    this.$toast.show('alert', msg, true);
                });
        },
        GetVerificaUltimaEtapa() {

            axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetVerificaUltimaEtapa?idOcorrencia=' + this.p_idOcorrencia, {
                headers: this.$api.getTokenComercial(),
                params: '',
                notLoading: true
            }).then(response => {
                this.$emit('liberaUltimaEtapa', response.data.data);

            })
        },
        setTable(result) {
            return result;
        },
        setActionCard(action) {
            this.$emit('setActionCard', action);
        },
    },
    mounted() {
        this.p_idOcorrencia = this.idOcorrencia;
        this.GetVerificaUltimaEtapa();

        this.updateSizeDinamic();
        window.addEventListener('resize', this.updateSizeDinamic);
    },
    updated() {
        this.updateSizeDinamic();
    },
    watch: {
        idOcorrencia(newVal, oldVal) {
            this.p_idOcorrencia = newVal;
            this.reloadGrids();
            this.GetVerificaUltimaEtapa();
            this.getOcorrencia();
        }
    },
}

</script>

<style scoped lang="scss">
.row.mt-2.row-text {
    >div {
        padding-left: 2px;
    }
}

.span-1 {
    font-size: 14px;
    font-weight: bold;
    color: #FF8A00;
}

.span-2 {
    font-size: 14px;
    font-weight: bold;
    color: #00AB11;
}

.label-tarefa {
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    color: #434343;
}

.label-alteracao {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    color: #434343;
}

.radio-group {
    display: flex;
    align-items: center;
}

.radio-label {
    display: flex;
    align-items: center;
    margin-right: 10px;
}

.radio-custom {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #FF8A00;
    position: relative;
    margin-right: 5px;
    cursor: pointer;
}

.radio-custom-done {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #00AB11;
    position: relative;
    margin-right: 5px;
    cursor: pointer;
}

.radio-label input[type="radio"]:checked+.radio-custom-done {
    border-color: #00AB11;
}

.radio-label input[type="radio"]:checked+.radio-custom-done::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    background-color: #00AB11;
    border-radius: 50%;
    display: block;
}

.radio-text {
    font-size: 12px;
}

.radio-label input[type="radio"] {
    opacity: 0;
    position: absolute;
    cursor: pointer;
}

.radio-label input[type="radio"]:checked+.radio-custom {
    border-color: #FF8A00;
}

.radio-label input[type="radio"]:checked+.radio-custom::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 10px;
    height: 10px;
    background-color: #FF8A00;
    border-radius: 50%;
    display: block;
}
</style>